module.exports = __webpack_public_path__ + "img/cert34.ca0477b7.jpg";